<ng-container *ngIf="!!dashboardView">
    <!--Header of the dashboard. This element is visible in PDF view only.-->
    <!--Even if it is not visible, it needs to be rendered for PDF exporting algorithm to be able-->
    <!--to get html-renderer component styles. This happens because, due to angular encapsulation,-->
    <!--the styles of a component are injected to the document only if the component is renderer elsewhere.-->
    <html-renderer *ngIf="container"
                   [class]="dashboardHeaderContainerClass"
                   [htmlCode]="dashboardHeaderHtmlCode"
                   [cssStyles]="dashboardHeaderCssStyles"
                   [containerClass]="dashboardHeaderClass"
                   [style.width]="container.offsetWidth + 'px'">
    </html-renderer>

    <div #container
         [id]="dashboardId"
         [class]="dashboardContainerClass"
         [ngClass]="dashboardContainerNgClass"
         [cssInjectionScope]="cssInjectionScopeId">

        <div class="dashboard-topbar">
            <h2 *ngIf="dashboardView.displayName">{{ dashboardView.name }}</h2>

            <!--This element is visible in web view only.-->
            <div class="dashboard-exporting-buttons">
                <p-button *ngIf="output === 'web' && exportable"
                          styleClass="p-button-lg p-button-outlined p-button-text p-button-icon-only"
                          class="exporting-button" icon="pi pi-file-pdf" title="Export to PDF"
                          [loading]="pdfExportingLoading | async" (onClick)="generatePdf()">
                </p-button>
                <p-button *ngIf="output === 'web' && exportable && dashboardId"
                          styleClass="p-button-lg p-button-outlined p-button-text p-button-icon-only"
                          class="exporting-button" icon="pi pi-file-excel" title="Export to XLS"
                          [loading]="xlsExportingLoading | async" (onClick)="generateXls()">
                </p-button>
            </div>
        </div>

        <!-- Empty dashboard -->
        <div class="empty-dashboard" *ngIf="!dashboardView.widgets?.length">
            <!--suppress AngularNgOptimizedImage -->
            <img class="dashboard-image" src="assets/images/reporting/dashboard.png" alt="">
            <div class="empty-message">
                <h2 class="mb-0">Empty dashboard</h2>
                <label class="dashboard-label mb-2">No widgets to display.</label>
            </div>
        </div>

        <!--Those styles are meant to be injected by the dashboard CSS editor-->
        <div *ngIf="dashboardView.showIM1RefreshButton" class="nhs-refresh-button-container">
            <button
                pButton
                class="nhs-refresh-button"
                label="Refresh data"
                [disabled]="loadingIm1Info"
                (click)="im1DataRefresh.emit()"></button>
        </div>

        <!-- IM1 message during loading or error calling the API-->
        <ng-container *ngIf="showIm1HtmlWidget">
            <html-renderer [htmlCode]="im1MessageHtmlCode" [cssStyles]="im1MessageCssRules"></html-renderer>
        </ng-container>

        <!-- Dashboard widgets -->
        <div [class]="widgetGridContainerClass" *ngIf="!!dashboardView.widgets?.length && !collapsed">

            <div [class]="separatorClass(0)"></div>

            <ng-container *ngFor="let row of dashboardGrid; let i = index">
                <div [class]="widgetRowClass" *ngIf="!!row?.length">

                    <div [class]="separatorClass(i, 0)"></div>

                    <ng-container *ngFor="let widget of row; let j = index">
                        <div *ngIf="!!widget"
                             [class]="widgetContainerClass(widget)"
                             [style]="widgetContainerStyle(widget)">

                            <reporting-widget [output]="output"
                                              [exportable]="false"
                                              [widgetType]="widget.widgetType"
                                              [staticVariables]="staticVariables"
                                              [widgetSourceId]="widget.widgetSourceId"
                                              (widgetComponentChange)="refreshWidget($event, i, j)">
                            </reporting-widget>

                        </div>

                        <div [class]="separatorClass(i, j + 1)">
                            <div [ngClass]="{'separator-bar': j + 1 < row.length}"></div>
                        </div>
                    </ng-container>
                </div>

                <div [class]="separatorClass(i + 1)">
                    <div [ngClass]="{'separator-bar' : i + 1 < dashboardGrid.length}"></div>
                </div>
            </ng-container>
        </div>

        <!-- Dashboard collapsed view -->
        <div *ngIf="collapsed">
            <h4 class="m-0 opacity-70">Show content</h4>
        </div>
    </div>

    <!--Footer of the dashboard. This element is visible in PDF view only.-->
    <!--Even if it is not visible, it needs to be rendered for PDF exporting algorithm to be able-->
    <!--to get html-renderer component styles. This happens because, due to angular encapsulation,-->
    <!--the styles of a component are injected to the document only if the component is renderer elsewhere.-->
    <html-renderer *ngIf="container"
                   [class]="dashboardFooterContainerClass"
                   [htmlCode]="dashboardFooterHtmlCode"
                   [cssStyles]="dashboardFooterCssStyles"
                   [containerClass]="dashboardFooterClass"
                   [style.width]="container.offsetWidth + 'px'">
    </html-renderer>
</ng-container>